// data.js
export const recentUploads = [
    {
      id: 1,
      fileName: 'PO_850_CustomerA_20231026.edi',
      customer: 'Customer A',
      date: '2023-10-26',
      status: 'Success',
      icon: 'FileText',
    },
    {
      id: 2,
      fileName: 'PO_Change_860_CustomerB_20231025.xml',
      customer: 'Customer B',
      date: '2023-10-25',
      status: 'Pending',
      icon: 'FilePen',
    },
    {
      id: 3,
      fileName: 'Invoice_900_CustomerC_20231024.csv',
      customer: 'Customer C',
      date: '2023-10-24',
      status: 'Failed',
      icon: 'FileText',
    },
    {
      id: 4,
      fileName: 'Order_850_CustomerD_20231023.json',
      customer: 'Customer D',
      date: '2023-10-23',
      status: 'Success',
      icon: 'FileText',
    },
    {
      id: 5,
      fileName: 'PO_850_CustomerE_20231022.edi',
      customer: 'Customer E',
      date: '2023-10-22',
      status: 'Pending',
      icon: 'FileText',
    },
  ];

  export const companySizeOptions = [
    { value: '1-10', label: '1-10 employees' },
    { value: '11-50', label: '11-50 employees' },
    { value: '51-200', label: '51-200 employees' },
    { value: '201-500', label: '201-500 employees' },
    { value: '501-1000', label: '501-1000 employees' },
    { value: '1000+', label: '1000+ employees' },
  ];

  export const countryOptions = [
    { value: 'USA', label: 'United States' },
    { value: 'CAN', label: 'Canada' },
    { value: 'MEX', label: 'Mexico' },
    { value: 'GBR', label: 'United Kingdom' },
    { value: 'DEU', label: 'Germany' },
    { value: 'FRA', label: 'France' },
    { value: 'AUS', label: 'Australia' },
    { value: 'IND', label: 'India' },
    { value: 'JPN', label: 'Japan' },
  ];

  export const fileFormatOptions = [
    { value: 'EDI', label: 'EDI' },
    { value: 'XML', label: 'XML' },
    { value: 'JSON', label: 'JSON' },
    { value: 'CSV', label: 'CSV' },
  ];

  export const customerOptions = [
    { value: 'customerA', label: 'Customer A' },
    { value: 'customerB', label: 'Customer B' },
    { value: 'customerC', label: 'Customer C' },
    { value: 'customerD', label: 'Customer D' },
    { value: 'customerE', label: 'Customer E' },
  ];
